export default "__VITE_ASSET__C9Gk0LAF__"